// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-weidner-classic-theme -> daymark-uptown
// Generated: 2026-11-03T21:12:05.323Z
// Counts: 0 design, 26 content, 25 slot group, 2 collection binding, 10 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities &amp; Luxuries</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "header.company_name": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Interactive Leasing</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxurydefinition.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "neighborhoodmap.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>High-Rise Sophistication in the Heart of Downtown <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "hero.tagline": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Urban Energy • Sky-High Sophistication • </strong><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "penthouse.featureList": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Quartz countertops with under-mount sinks</li><li>Custom cabinetry with under-cabinet finishes</li><li>Stainless steel refrigerator, oven, microwave and dishwasher</li><li>Gas range</li><li>Luxury hardwood plank-style flooring</li><li>9–10' ceilings</li><li>Oversized windows with window treatments</li><li>Lake or city views</li><li>Garden soaking tubs</li><li>Walk-in closets</li><li>Full-size washer and dryer</li><li>Indoor/outdoor fireplace</li><li>Oversized balcony</li><li>Wired for data, audio and video</li></ul>",
    "mappedField": null
  },
  "petpolicy.dogs_restrictions": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Pit Bull &amp; Pit Bull Mixes</li><li>American Pit Bull Terrier</li><li>American Staffordshire Terrier</li><li>Wolf Hybrids</li><li>Doberman Pinscher</li><li>Saint Bernard</li></ul><ul><li>American Bulldog</li><li>Staffordshire Bull Terrier</li><li>German Shepherd</li><li>Chow Chow</li><li>Great Dane</li><li>Akita</li></ul>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.qualifying_criteria_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/company/5726763346821120/01a0edf8-50e1-766e-be36-fe17d735f389.pdf"
      }
    }
  },
  "specialofferbanner.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "amenitieslist.apartmentPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-714f-701b-af7d-ad2eb38cb749.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances, gas range, and ample cabinet space."
      }
    }
  },
  "amenitieslist.apartmentPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-9044-77bb-9448-e14fda969f88.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stylish living area with gray sofa, burgundy accent chair, modern art, and decorative wall pieces."
      }
    }
  },
  "amenitieslist.apartmentPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-b467-7735-8035-d81db4ae2735.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy bedroom with a queen-sized bed, decorative rug, and bedside lamp."
      }
    }
  },
  "amenitieslist.apartmentPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-4a17-749d-a2e9-2915a66e4fe6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double sinks, a bathtub, and white subway tile shower surround."
      }
    }
  },
  "amenitieslist.communityPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-5762-717a-ab33-2f8beb39b589.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas."
      }
    }
  },
  "amenitieslist.communityPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-5530-7419-81db-3518b0c9acfc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gym with various weight machines, treadmills, and stationary bikes."
      }
    }
  },
  "amenitieslist.communityPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-6022-7549-850e-838e8ff10e16.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern rooftop lounge area with red seating and a fire pit."
      }
    }
  },
  "amenitieslist.communityPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-c339-71de-b064-0fd2f54e7cda.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby with reception desk, modern seating, and large windows."
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[33].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[33].image_media.alt_text"
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "luxurydefinition.propertygraphic": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178f0-068e-777e-9eca-468fb26fe474.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of Daymark Uptown, a modern brick-accented apartment building in Minneapolis framed by autumn trees"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "penthouse.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-d1bd-746a-8f90-3344b09120f6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island, dining area, and living room with fireplace."
      }
    }
  },
  "penthouse.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-a4a7-70cc-9208-dd71f82f3c40.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sofa, coffee table, rug, and large window with city view."
      }
    }
  },
  "penthouse.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-bd75-7577-bfc9-c3a89695f26f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with large windows and a city view at dusk."
      }
    }
  },
  "penthouse.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a4-4a17-749d-a2e9-2915a66e4fe6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double sinks, a bathtub, and white subway tile shower surround."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "urban-studio-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_306e7f5c52ecd705295c634f"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "tabbedcallouts.slides": {
    "limit": null,
    "hiddenIds": [
      "ec_306e7f5c52ecd705295c634f",
      "ec_fe41613404b46f5dbb1d3eab",
      "ec_89067cff8a8bbb5daa7d40f6"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "interactive-leasing-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
